import React from "react";
import { Route, Navigate } from "react-router-dom";
import MenuPage from "./pages/client/Home/QrMenuPage";
import AdminPanelFirebase from "./components/AdminPanelFirebase";
import LoginForm from "./components/LoginForm";
import AbouteMe from "./pages/AbouteMe/AbouteMe";
import Contact from "./pages/Contact/Contact";

const ADMIN_EMAILS = ["admin@tjvjik.am","dmin@king.am"];

export const getRoutes = (user) => [
  <Route key="/" path="/" element={<MenuPage />} />,
  

  // ✅ About Page Route
  <Route key="/about" path="/about" element={<AbouteMe />} />,
  <Route key="/contact" path="/contact" element={<Contact />} />,
  <Route
    key="/admin"
    path="/admin"
    element={
      user && ADMIN_EMAILS.includes(user.email) ? (
        <AdminPanelFirebase />
      ) : (
        <LoginForm />
      )
    }
  />,
  <Route key="*" path="*" element={<Navigate to="/" />} />,
];
